import { IsoDate, IsoDateTime, IsoTime } from '../../types/iso-date';
import { deconstructDate } from '../helper/deconstruct-date.function';
import { constructDate } from '../helper/construct-date.function';

export function setTime<T extends IsoDate | IsoDateTime>(date: T, time: IsoTime): IsoDateTime {
  const deconstructedDate = deconstructDate(date);
  const deconstructedTime = deconstructDate(time);
  return constructDate({...deconstructedDate, ...deconstructedTime, _type: 'dateTime'});
}
